import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function TreatmentAreasSection() {
  const {
    t
  } = useLanguage();
  const areas = [{
    title: t('treatment.nasolabial'),
    description: t('treatment.nasolabialDesc'),
    points: ['Immediate volume restoration', 'Natural facial expressions', 'Lasts up to 12 months']
  }, {
    title: t('treatment.lips'),
    description: t('treatment.lipsDesc'),
    points: ['Soft, natural feel', "Enhanced cupid's bow", 'Reduced perioral lines']
  }, {
    title: t('treatment.cheeks'),
    description: t('treatment.cheeksDesc'),
    points: ['High lifting capacity', 'Restores youthful triangle', 'Lasts up to 18 months']
  }, {
    title: t('treatment.jawline'),
    description: t('treatment.jawlineDesc'),
    points: ['Sharpens facial contours', 'Improves facial harmony', 'Non-surgical alternative']
  }];
  return <section id="treatment-areas" className="py-24 bg-white" data-id="element-742">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-743">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-744">
          {/* Left: Image with treatment markers */}
          <div className="order-2 lg:order-1 relative" data-id="element-745">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden relative border-8 border-white shadow-xl" data-id="element-746">
              <img src="https://cdn.magicpatterns.com/uploads/nFGCKEeqZkr8ajMMmkfdZG/435.jpg" alt="Singderm filler treatment areas" className="w-full h-full object-cover" data-id="element-747" />

              {/* Forehead */}
              <div className="absolute top-[38%] left-[50%] -translate-x-1/2 flex items-center gap-1.5" data-id="element-748">
                <div className="w-3.5 h-3.5 bg-brand-copper rounded-full shadow-[0_0_12px_rgba(40,99,147,0.8)] animate-pulse border-2 border-white" data-id="element-749"></div>
                <span className="text-[10px] font-semibold text-white bg-brand-copper/80 backdrop-blur-sm px-2 py-0.5 rounded-full whitespace-nowrap shadow-md" data-id="element-750">
                  Forehead
                </span>
              </div>

              {/* Temple */}
              <div className="absolute top-[47%] left-[68%] flex items-center gap-1.5" data-id="element-751">
                <div className="w-3.5 h-3.5 bg-brand-copper rounded-full shadow-[0_0_12px_rgba(40,99,147,0.8)] animate-pulse border-2 border-white" style={{
                animationDelay: '0.2s'
              }} data-id="element-752"></div>
                <span className="text-[10px] font-semibold text-white bg-brand-copper/80 backdrop-blur-sm px-2 py-0.5 rounded-full whitespace-nowrap shadow-md" data-id="element-753">
                  Temple
                </span>
              </div>

              {/* Cheek */}
              <div className="absolute top-[57%] left-[37%] flex items-center gap-1.5" data-id="element-754">
                <span className="text-[10px] font-semibold text-white bg-brand-copper/80 backdrop-blur-sm px-2 py-0.5 rounded-full whitespace-nowrap shadow-md" data-id="element-755">
                  Cheek
                </span>
                <div className="w-3.5 h-3.5 bg-brand-copper rounded-full shadow-[0_0_12px_rgba(40,99,147,0.8)] animate-pulse border-2 border-white" style={{
                animationDelay: '0.4s'
              }} data-id="element-756"></div>
              </div>

              {/* Nasolabial Folds */}
              <div className="absolute top-[63%] left-[60%] flex items-center gap-1.5" data-id="element-757">
                <div className="w-3.5 h-3.5 bg-brand-copper rounded-full shadow-[0_0_12px_rgba(40,99,147,0.8)] animate-pulse border-2 border-white" style={{
                animationDelay: '0.6s'
              }} data-id="element-758"></div>
                <span className="text-[10px] font-semibold text-white bg-brand-copper/80 backdrop-blur-sm px-2 py-0.5 rounded-full whitespace-nowrap shadow-md" data-id="element-759">
                  Nasolabial Folds
                </span>
              </div>

              {/* Marionette Lines */}
              <div className="absolute top-[68%] left-[64%] flex items-center gap-1.5" data-id="element-760">
                <div className="w-3.5 h-3.5 bg-brand-copper rounded-full shadow-[0_0_12px_rgba(40,99,147,0.8)] animate-pulse border-2 border-white" style={{
                animationDelay: '0.8s'
              }} data-id="element-761"></div>
                <span className="text-[10px] font-semibold text-white bg-brand-copper/80 backdrop-blur-sm px-2 py-0.5 rounded-full whitespace-nowrap shadow-md" data-id="element-762">
                  Marionette Lines
                </span>
              </div>

              {/* Jawline Contouring */}
              <div className="absolute top-[70%] left-[40%] flex items-center gap-1.5" data-id="element-763">
                <span className="text-[10px] font-semibold text-white bg-brand-copper/80 backdrop-blur-sm px-2 py-0.5 rounded-full whitespace-nowrap shadow-md" data-id="element-764">
                  Jawline Contouring
                </span>
                <div className="w-3.5 h-3.5 bg-brand-copper rounded-full shadow-[0_0_12px_rgba(40,99,147,0.8)] animate-pulse border-2 border-white" style={{
                animationDelay: '1s'
              }} data-id="element-765"></div>
              </div>

              {/* Chin Contouring */}
              <div className="absolute top-[78%] left-[50%] -translate-x-1/2 flex items-center gap-1.5" data-id="element-766">
                <div className="w-3.5 h-3.5 bg-brand-copper rounded-full shadow-[0_0_12px_rgba(40,99,147,0.8)] animate-pulse border-2 border-white" style={{
                animationDelay: '1.2s'
              }} data-id="element-767"></div>
                <span className="text-[10px] font-semibold text-white bg-brand-copper/80 backdrop-blur-sm px-2 py-0.5 rounded-full whitespace-nowrap shadow-md" data-id="element-768">
                  Chin Contouring
                </span>
              </div>
            </div>
            {/* Background decoration */}
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-brand-lightCopper/20 rounded-full -z-10 blur-3xl" data-id="element-769"></div>
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-brand-copper/10 rounded-full -z-10 blur-3xl" data-id="element-770"></div>
          </div>

          {/* Right: Content */}
          <div className="order-1 lg:order-2" data-id="element-771">
            <h2 className="text-sm font-bold tracking-widest text-brand-copper uppercase mb-3" data-id="element-772">
              {t('treatment.label')}
            </h2>
            <h3 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 leading-tight" data-id="element-773">
              {t('treatment.title1')}{' '}
              <span className="font-semibold" data-id="element-774">{t('treatment.title2')}</span>
            </h3>
            <p className="text-gray-600 mb-10 leading-relaxed" data-id="element-775">
              {t('treatment.subtitle')}
            </p>

            <div className="space-y-8" data-id="element-776">
              {areas.map((area, index) => <div key={index} className="flex" data-id="element-777">
                  <div className="flex-shrink-0 mt-1" data-id="element-778">
                    <div className="w-8 h-8 rounded-full bg-brand-lightCopper/50 flex items-center justify-center text-brand-darkCopper font-semibold text-sm" data-id="element-779">
                      0{index + 1}
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-780">
                    <h4 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-781">
                      {area.title}
                    </h4>
                    <p className="text-gray-600 text-sm mb-3" data-id="element-782">
                      {area.description}
                    </p>
                    <ul className="flex flex-wrap gap-2" data-id="element-783">
                      {area.points.map((point, idx) => <li key={idx} className="text-xs font-medium bg-gray-100 text-gray-600 px-2 py-1 rounded" data-id="element-784">
                          {point}
                        </li>)}
                    </ul>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}